<div style="display: flex; flex-direction: row;justify-content:space-between;">
  <div class="rfq-create-form" [ngClass]="{ 'full-width-container1': !showDetailSection, 'half-width-container1': showDetailSection }" style="display: flex; flex-direction: column;overflow-x: hidden;">
      <div class="rfq-create-form-title">

          <div style="display: flex;flex-direction:row;justify-content:space-between;margin-top:10px;margin-bottom:5px">
              <div id="createquotation">
                View Purchase Order
              </div>
              <button mat-button color="primary"
                    style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px;"
                    (click)="close(true)">Close<mat-icon>navigate_next</mat-icon></button>
          </div>
      </div>

      <div class="col-xl-10 col-lg-9 col-9 p-0 card-body-fixheight z-index-4" style="width: 100%;">
          <mat-card class="p-0" style="margin: 0 0.5rem">
              <mat-card-content class="ship-fscoll hgt ship-pr-sec">
                  <nav mat-tab-nav-bar class="tagGroup">
                      <a mat-tab-link *ngFor="let tabItem of tabs; let idx = index"
                          [class.active-link]="currentTab === tabItem.route" class="teb_icon"
                          (click)="selectMatTabLink(tabItem)">
                          <span id="navstepstext">{{tabItem.label}}</span>
                      </a>
                  </nav>

                  <!-- Port Agent Details Missing Warning Banner (Now using snackbar on button click) -->
                  <!-- <div *ngIf="isPortAgentMissing" class="port-agent-warning-banner">
                      <div class="warning-content">
                          <mat-icon class="warning-icon">warning</mat-icon>
                          <div class="warning-text">
                              <strong>Port Agent Details Required</strong>
                              <p>Please fill in the Port Agent Details on the Payment Terms tab before submitting the Purchase Order.</p>
                          </div>
                          <button mat-raised-button color="primary" class="go-to-payment-btn" (click)="goToPaymentTermsTab()">
                              Go to Payment Terms
                          </button>
                      </div>
                  </div> -->

                  <div #pdfContent style="width:100%;">

                      <div>
                          <div style="display: flex;justify-content: space-between;align-items: center;margin-top:30px">
                            <div>
                              <form [formGroup]="secondFormGroup">
                                <div class="form-item-row" style="flex-direction: column-reverse;">
                                    <div style="display: flex; flex-direction: column; width: 100%; height:  100%;">
                                        <label>Preferred Currency<span class="required-star" style="color: red;margin-left: 2px;">*</span></label>
                                        <app-paginated-autocomplete-manual style="background-color: white!important; margin-bottom: 10px; color: white!important;" [displayWithFunc]="filterFieldCurrencyNameDisplayFn"
                                        [dataSrc]="boundGetCurrencyAutoComplete" [controlName]="'supplierCurrency'" [control]="getCurrencyControl()"
                                        [readonly]="true" >
                                    </app-paginated-autocomplete-manual>
                                    </div> 
                                    <small *ngIf="secondFormGroup || secondFormGroup['controls']['supplierCurrency']['dirty'] || secondFormGroup['controls']['supplierCurrency']['touched']" class="form-error-msg">
                                        <div style="padding:2px;" *ngIf="secondFormGroup.controls['supplierCurrency'].hasError('required')">
                                            *Currency should not be empty.
                                        </div>
                                    </small>
                                    <small class="form-error-msg" style="color: blue;">
                                      <div style="padding:2px;" >
                                        1 {{ secondFormGroup.get('supplierCurrency')?.value?.currencyCode || 'No Currency' }} = 1 {{headerData?.currencyId?.currencyCode}} 
                                       ( as of {{currentdate }})
                                      </div>
                                  </small>
                                </div> 
                                
                              </form>
                            </div>
                            
                          </div>
                          <div style="display: flex; flex-direction: column; overflow-x: auto; width: 100%;margin-top:70px">
                              
                              <form [formGroup]="lineItemtableForm">

                                <ngx-datatable
                                  #table
                                  class="material expandable"
                                  [rows]="dataSource"
                                  [headerHeight]="50"
                                  [footerHeight]="50"
                                  [rowHeight]="'auto'"
                                  [columnMode]="'force'"
                                  [scrollbarH]="true"
                                  [externalPaging]="false"
                                  [externalSorting]="false"
                                  [limit]="10"
                                  >
                                
                                  <ngx-datatable-column name="S.No." [width]="100">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('position')" readonly style="width: 40px;" 
                                      [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Part Number">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      
                                      <ng-container *ngIf="isNew(rowIndex)" >
                                          <app-paginated-autocomplete-manual
                                          [displayWithFunc]="filterFieldSupplierProductNameDisplayFn"
                                          [dataSrc]="boundGetSupplierProductAutoComplete"
                                          [controlName]="'addedLineItempartNumber'"
                                          [control]="getPartNumberControl(rowIndex)"
                                          [placeholder]="'Select Part NUmber'"
                                          [label]="'Part Number'"
                                          (autoCompleteOptionSelected)="onPartNumberSelected($event,rowIndex)"
                                        >
                                        </app-paginated-autocomplete-manual>

                                      
                                        
                                      </ng-container>

                                      <ng-container *ngIf="!isNew(rowIndex)">
                                        <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('partNumber')" readonly 
                                        [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                      </ng-container>
                                      
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Supplier Part Number">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('supplierPartNumber')" readonly 
                                      [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                     
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Item Description">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <textarea matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('itemDescription')"
                                        [disabled]="true" readonly
                                        [ngClass]="{ 'expanded-input': isWrapDescription }"
                                        [rows]="isWrapDescription ? 4 : 1"
                                        matTooltipClass="mat-tooltip-custom"
                                        [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"
                                        ></textarea>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Buyer Comment">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <textarea matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('buyerComment')"
                                        [disabled]="true" readonly
                                        [ngClass]="{ 'expanded-input': isWrapDescription }"
                                        [rows]="isWrapDescription ? 4 : 1"
                                        [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"
                                        ></textarea>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Supplier Comment">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <textarea matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('supplierComment')"
                                        [ngClass]="{ 'expanded-input': isWrapDescription }"
                                        [rows]="isWrapDescription ? 4 : 1"
                                        readonly
                                        [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"
                                        ></textarea>
                                    </ng-template>
                                  </ngx-datatable-column>
                                  
                                  <ngx-datatable-column name="Customs Code">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('customsCode')" readonly
                                      [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Requested Quantity">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('quantity')"
                                        [disabled]="true" readonly onkeypress="return event.charCode >= 48 && event.charCode <= 57" 
                                        [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column  name="Quoted Quantity">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('supplierQuantity')"
                                        (blur)="calculateRowValues(rowIndex)"
                                        onkeypress="return event.charCode >= 48 && event.charCode <= 57" readonly
                                        [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Requested UOM">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('uom')" readonly style="width: 100px;" 
                                      [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Quoted UOM">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput pattern="[A-Za-z\\s]*" style="width: 100px;" [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('supplierUom')" readonly (keypress)="allowOnlyLetters($event)" 
                                      [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Quoted Unit Cost" [sortable]="true" [width]="220">
                                    <ng-template ngx-datatable-header-template let-column="column">
                                      <div class="datatable-header-flex">
                                        <span class="datatable-header-text">
                                          Quoted Unit Cost <span class="required-star">*</span>
                                        </span>
                                  
                                        <mat-slide-toggle
                                          (change)="getColumn('requestedUnitCost') ? showToggleColumns(getColumn('requestedUnitCost')) : null" 
                                          [checked]="getColumn('requestedUnitCost')?.visible"
                                          class="ml-2">
                                        </mat-slide-toggle>
                                  
                                        <button mat-icon-button style="padding: 0px;"
                                          [matTooltip]="'Currency conversion is powered by ExchangeRate-API and locked at entry.'">
                                          <mat-icon>info</mat-icon>
                                        </button>
                                  
                                        <!-- This renders the built-in sort icon -->
                                        <span class="datatable-sort-icon" [class.active]="column.sort?.dir">
                                          <i [ngClass]="{
                                            'fa fa-caret-up': column.sort?.dir === 'asc',
                                            'fa fa-caret-down': column.sort?.dir === 'desc'
                                          }"></i>
                                        </span>
                                      </div>
                                    </ng-template>
                                  
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input type="number" matInput 
                                        [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('unitCost')"
                                        (blur)="calculateRowValues(rowIndex)" 
                                        [disabled]="true" step="any" 
                                        readonly
                                        [matTooltip]="getDeclineReason(rowIndex)" 
                                        [matTooltipDisabled]="!isDecline(rowIndex)" />
                                    </ng-template>
                                  </ngx-datatable-column>
                            

                                  <ngx-datatable-column type='button' name="Requested Unit Cost">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      {{headerData?.currencyId?.currencyCode}} {{ lineItemtableForm.get('rows')['controls'][rowIndex].get('unitCost').value | number: '1.3-3' }}
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Discount">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      {{ lineItemtableForm.get('rows')['controls'][rowIndex].get('discount').value | number: '1.3-3' }}
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Quoted Total Cost" [sortable]="true" [width]="220">
                                    <ng-template ngx-datatable-header-template let-column="column">
                                      <div class="datatable-header-flex">
                                        <span class="datatable-header-text">Quoted Total Cost</span>
                                  
                                        <mat-slide-toggle
                                          (change)="getColumn('requestedTotalCost') ? showToggleColumns(getColumn('requestedTotalCost')) : null" 
                                          [checked]="getColumn('requestedTotalCost')?.visible"
                                          class="ml-2">
                                        </mat-slide-toggle>
                                  
                                        <button mat-icon-button style="padding: 0px;"
                                          [matTooltip]="'Currency conversion is powered by ExchangeRate-API and locked at entry.'">
                                          <mat-icon>info</mat-icon>
                                        </button>
                                  
                                        <span class="datatable-sort-icon" [class.active]="column.sort?.dir">
                                          <i [ngClass]="{
                                            'fa fa-caret-up': column.sort?.dir === 'asc',
                                            'fa fa-caret-down': column.sort?.dir === 'desc'
                                          }"></i>
                                        </span>
                                      </div>
                                    </ng-template>
                                  
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input type="number" matInput 
                                        [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('totalCost')"
                                        [disabled]="true" step="any" readonly
                                        [matTooltip]="getDeclineReason(rowIndex)" 
                                        [matTooltipDisabled]="!isDecline(rowIndex)" />
                                    </ng-template>
                                  </ngx-datatable-column>
                                  

                                  <ngx-datatable-column type='button' name="Requested Total Cost">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                        {{headerData?.currencyId?.currencyCode}} {{ lineItemtableForm.get('rows')['controls'][rowIndex].get('totalCost').value | number: '1.3-3' }}
                                    
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Lead Time">
                                    <ng-template ngx-datatable-header-template let-column="column">
                                      Lead Time <span class="required-star">*</span>
                                    </ng-template>
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input type="number" matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('leadTime')" style="width: 100px;" readonly 
                                      [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>


                                  <!-- <ngx-datatable-column type='button' *ngIf="getColumn('attachments')?.visible" name="Attachments">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <button mat-icon-button (click)="toggleSidebar(true, 'attachment', rowIndex)" [disabled]="isDecline(rowIndex)">
                                        <mat-icon>add_circle</mat-icon>
                                      </button>
                                    </ng-template>
                                  </ngx-datatable-column> -->

                                  <!-- <ngx-datatable-column name="" [width]="80">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                  
                                      <button type='button' *ngIf="!isDecline(rowIndex)" mat-icon-button class="delete-icon-button" (click)="toggleSidebar(true, 'decline', rowIndex)">
                                        <mat-icon>close</mat-icon>
                                      </button>

                                      <button type='button' *ngIf="isDecline(rowIndex)" mat-icon-button class="delete-icon-button" (click)="restoreLineitem(rowIndex)">
                                        <mat-icon>restore</mat-icon>
                                      </button>
                                    </ng-template>
                                  </ngx-datatable-column> -->
                                </ngx-datatable>
                              </form>

                          </div>
                          <div class="secondformcontainerfull" style="margin: 30px;float:right;">
                            <form [formGroup]="secondFormGroup">
                              <div class="floating-card-container">
                                <div class="floating-card">
                                  <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 20px; font-weight: bold;">
                                    <span><b>Total <span *ngIf="secondFormGroup.get('supplierCurrency')?.value?.currencyCode!== null">
                                      ({{ secondFormGroup.get('supplierCurrency')?.value.currencyCode}})
                                    </span></b></span>
                                    <span>{{ (secondFormGroup.get('quoteLineItemTotal')?.value || 0) | number: '1.3-3' }}</span>
                                  </div>
                                  <div class="card-body mx-4">
                                     <div class="container">
                                        
                                        <div class="row">
                                          <hr>
                                          <div class="col-xl-10">
                                            <p>Line Item list Price Sub Total</p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input type="number" matInput [formControlName]="'quoteLineItemListPriceSubtotal'" [disabled]="true" step="any" readonly />
                                            </p>
                                          </div>
                                          <div class="col-xl-10">
                                            <p>Line Item Discount</p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input type="number" matInput [formControlName]="'quoteLineItemDiscount'" [disabled]="true" step="any" readonly />

                                            </p>
                                          </div>
                                          <div class="col-xl-10">
                                            <p><b>Line Item Sub Total</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input type="number" matInput [formControlName]="'quoteLineItemSubtotal'" [disabled]="true" step="any" readonly />

                                            </p>
                                          </div>
                                          <hr>
                                        </div>
                                        <div class="row">
                                          <div class="col-xl-10">
                                            <p><b>General Discount</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <select formControlName="quoteLineItemGeneralDiscountType" [disabled]="true" readonly style="width: 100%; margin-bottom: 10px;">
                                                <option value="percentage">Percentage</option>
                                                  <!-- <option value="amount"> value</option> -->
                                                  
                                                </select>
                                              <input type="number" matInput [formControlName]="'quoteLineItemGeneralDiscountValue'"  step="any"  (blur)="calculateCostSummary()" readonly/>

                                            </p>
                                          </div>
                                          <hr>
                                        </div>

                                        <div class="row">
                                          <div class="col-xl-10">
                                            <p><b>Applicable Tax Profile</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <select formControlName="quoteLineItemApplicableTaxProfile" style="width: 100%; margin-bottom: 10px;" (change)="calculateCostSummary()" [disabled]="true">
                                                <option *ngFor="let item of taxStatusData" [value]="item.taxId">
                                                  {{ item.nameOfTaxProfile }} - {{ item.country?.name }} - {{ item.taxType }} ({{item.regionName}}) - {{ item.taxNumber }} - {{ item.taxPercentage }} %
                                                </option>                                                  
                                                </select>
                                              <input type="number" matInput [formControlName]="'quoteLineItemTaxAmount'"  step="any" readonly (blur)="calculateCostSummary()"/>

                                            </p>
                                          </div>
                                          <hr>
                                        </div>

                                        <!-- <div class="row">
                                          <div class="col-xl-10">
                                            <p><b>Freight</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              
                                              
                                            </p>
                                            
                                          </div>
                                          
                                          <div style="display:flex;justify-content: flex-end;margin-bottom: 10px">
                                            <input type="number" matInput [formControlName]="'quoteLineItemFreightTotal'"  step="any" (blur)="calculateCostSummary()" readonly/>
                                          </div>
                                          <hr style="border: 1px solid white;">
                                        </div> -->

                                        <div class="row">
                                          <div class="col-xl-12" *ngIf="secondFormGroup.get('quoteLineItemFreight')?.value?.length > 0">
                                            <div
                                              *ngFor="let item of secondFormGroup.get('quoteLineItemFreight')?.value"
                                              class="d-flex align-items-center justify-content-between mb-2"
                                            >
                                              <label class="fw-bold me-2" style="min-width: 100px;">
                                                {{ item.freightDescription }}
                                              </label>

                                              <div class="freight-wrapper">
                                                <!-- <input
                                                  type="number"
                                                  matInput
                                                  [value]="item.freightValue"
                                                  step="any"
                                                  readonly
                                                /> -->
                                                <input
                                                  type="text"
                                                  matInput
                                                  [value]="item.freightValue | number : '1.3-3'"
                                                  readonly
                                                />
                                                <!-- <button
                                                  *ngIf="item.freightDescription?.trim()?.toLowerCase() === 'freight'"
                                                  mat-icon-button
                                                  matTooltip="Remove Freight"
                                                  matTooltipPosition="below"
                                                  (click)="toggleSidebar(true, 'freight')"
                                                  class="remove-btn"
                                                >
                                                  <span class="freight-icon-circle">
                                                    <mat-icon>close</mat-icon>
                                                  </span>
                                                </button> -->
                                              </div>
                                            </div>
                                          </div>

                                          <div class="col-xl-10">
                                            <!-- <p><b>Freight Total</b></p> -->
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input
                                                type="number"
                                                matInput
                                                [formControlName]="'quoteLineItemFreightTotal'"
                                                step="any"
                                                (blur)="calculateCostSummary()"
                                                readonly
                                              />
                                            </p>
                                          </div>
                                          <hr style="border: 1px solid white;" />
                                        </div>
                                        <div class="row text-black">
                                  
                                          <div class="col-xl-12">
                                            <p class="float-end fw-bold" style="color: white !important;"> Total: 
                                              <input type="number" matInput [formControlName]="'quoteLineItemTotal'" [disabled]="true" step="any" readonly />
                                            </p>
                                          </div>
                                          <hr style="border: 1px solid white;">
                                        </div>
                                      
                                  
                                      </div>
                                  </div>
                                </div>
                              </div>
                        </form>
                        </div>

                      </div>

                  </div>
                  <div style="width:100%;">
                            
                            <form [formGroup]="firstFormGroup">
                            <div>

                                <!-- Purchase Order Details -->
                                <div class="header-form-header">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form1')">
                                    Purchase Order Details
                                    <mat-icon>{{ isForm1Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm1Expand" class="three-column-flex">

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Purchase Order Number</mat-label>
                                        <input matInput formControlName="purchaseOrderRefNumber" readonly>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Purchase Order Date</mat-label>
                                        <input matInput [matDatepicker]="poDate" formControlName="purchaseOrderDate" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="poDate" [disabled]="true"></mat-datepicker-toggle>
                                        <mat-datepicker #poDate></mat-datepicker>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>RFQ Ref Number</mat-label>
                                        <input matInput formControlName="rfqRefNumber" readonly>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>RFQ Date</mat-label>
                                        <input matInput [matDatepicker]="rfqDate" formControlName="rfqDate" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="rfqDate" [disabled]="true"></mat-datepicker-toggle>
                                        <mat-datepicker #rfqDate></mat-datepicker>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Quote Ref Number</mat-label>
                                        <input matInput formControlName="quoteRefNumber" readonly>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Quotation Date</mat-label>
                                        <input matInput [matDatepicker]="quotationDate" formControlName="quotationDate" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="quotationDate" [disabled]="true"></mat-datepicker-toggle>
                                        <mat-datepicker #quotationDate></mat-datepicker>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Expected Delivery Date</mat-label>
                                        <input matInput [matDatepicker]="expectedDeliveryDate" formControlName="expectedDeliveryDate" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="expectedDeliveryDate" [disabled]="true"></mat-datepicker-toggle>
                                        <mat-datepicker #expectedDeliveryDate></mat-datepicker>
                                    </mat-form-field>
                                    </div>
                                </div>
                                </div>

                                <!-- Buyer Company Details -->
                                <div class="header-form-header">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form2')">
                                    Buyer Company Details
                                    <mat-icon>{{ isForm2Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm2Expand" class="three-column-flex">
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Buyer Name</mat-label>
                                        <input matInput formControlName="buyerName" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Email Id</mat-label>
                                        <input matInput formControlName="buyerEmail" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Phone</mat-label>
                                        <input matInput formControlName="buyerPhone" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Fax</mat-label>
                                        <input matInput formControlName="buyerFax" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Address</mat-label>
                                        <input matInput formControlName="buyerAddress" readonly>
                                    </mat-form-field>
                                    </div>
                                </div>
                                </div>

                                <!-- Buyer Details -->
                                <div class="header-form-header">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form3')">
                                    Buyer Details
                                    <mat-icon>{{ isForm3Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm3Expand" class="three-column-flex">
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Contact Person (Job Title)</mat-label>
                                        <input matInput formControlName="buyerContactPerson" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Email Id</mat-label>
                                        <input matInput formControlName="buyerContactEmail" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Phone</mat-label>
                                        <input matInput formControlName="buyerContactPhone" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Fax</mat-label>
                                        <input matInput formControlName="buyerContactFax" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Address</mat-label>
                                        <input matInput formControlName="buyerContactAddress" readonly>
                                    </mat-form-field>
                                    </div>
                                </div>
                                </div>

                                <!-- Supplier Details -->
                                <div class="header-form-header">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form4')">
                                    Supplier Details
                                    <mat-icon>{{ isForm4Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm4Expand" class="three-column-flex">
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Supplier Contact Name</mat-label>
                                        <input matInput formControlName="supplierContactName" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Email Id</mat-label>
                                        <input matInput formControlName="supplierEmail" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Phone</mat-label>
                                        <input matInput formControlName="supplierPhone" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Fax</mat-label>
                                        <input matInput formControlName="supplierFax" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Company Email</mat-label>
                                        <input matInput formControlName="supplierCompanyEmail" readonly>
                                    </mat-form-field>
                                    </div>
                                </div>
                                </div>

                                <!-- Vessel Details -->
                                <div class="header-form-header">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form5')">
                                    Vessel Details
                                    <mat-icon>{{ isForm5Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm5Expand" class="three-column-flex">
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Vessel Name</mat-label>
                                        <input matInput formControlName="vesselName" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Vessel IMO Number</mat-label>
                                        <input matInput formControlName="vesselIMONumber" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Vessel Type</mat-label>
                                        <input matInput formControlName="vesselType" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Class</mat-label>
                                        <input matInput formControlName="vesselClass" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                        <mat-form-field class="full-width" color="accent">
                                            <mat-label>Hull Number</mat-label>
                                            <input matInput formControlName="hullNumber" readonly>
                                        </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                        <mat-form-field class="full-width" color="accent">
                                            <mat-label>Yard Name</mat-label>
                                            <input matInput formControlName="yardName" readonly>
                                        </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                        <mat-form-field class="full-width" color="accent">
                                            <mat-label>Year Built</mat-label>
                                            <input matInput formControlName="yearBuilt" readonly>
                                        </mat-form-field>
                                    </div>
                                </div>
                                </div>

                                <!-- Port Details -->
                                <div class="header-form-header">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form6')">
                                    Port Details
                                    <mat-icon>{{ isForm6Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm6Expand" class="three-column-flex">
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Port Name</mat-label>
                                        <input matInput formControlName="portName" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Port Code</mat-label>
                                        <input matInput formControlName="portCode" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Vessel ETA</mat-label>
                                        <input matInput [matDatepicker]="vesselETA" formControlName="vesselETA" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="vesselETA" [disabled]="true"></mat-datepicker-toggle>
                                        <mat-datepicker #vesselETA></mat-datepicker>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Vessel ETD</mat-label>
                                        <input matInput [matDatepicker]="vesselETD" formControlName="vesselETD" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="vesselETD" [disabled]="true"></mat-datepicker-toggle>
                                        <mat-datepicker #vesselETD></mat-datepicker>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                        <mat-form-field class="full-width" color="accent">
                                            <mat-label>Vessel ETB</mat-label>
                                            <input matInput name="vesselEtb" formControlName="vesselETB"
                                                [matDatepicker]="vesselEtbDatepicker" readonly/>
                                            
                                            <mat-datepicker-toggle matSuffix [for]="vesselEtbDatepicker" [disabled]="true"></mat-datepicker-toggle>
                                        </mat-form-field>
                                        <mat-datepicker #vesselEtbDatepicker></mat-datepicker>
                                    </div>
                                </div>
                                </div>

                            </div>
                        </form>

                  </div>
                  <div style="width:100%;">
                    <form [formGroup]="paymentFormGroup">
                        <!-- Buyer Payment Terms -->
                        <div class="header-form-header">
                        <span
                            style="
                            padding-left: 16px;
                            padding-top: 16px;
                            margin-bottom: 32px;
                            font-weight: bold;
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;
                            "
                            (click)="toggleVisibility('form9')"
                        >
                            Buyer Payment Terms
                            <mat-icon>{{
                            isForm9Expand ? "minimize" : "add"
                            }}</mat-icon>
                        </span>

                        <div *ngIf="isForm9Expand" class="three-column-flex">
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Billing Address</mat-label>
                                <input matInput formControlName="billingAddress" readonly/>
                            </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Applicable Tax Profile</mat-label>
                                <input
                                matInput
                                formControlName="applicableTaxProfile"
                                readonly
                                />
                            </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Buyers Payment Terms</mat-label>
                                <input matInput formControlName="buyersPaymentTerms" readonly/>
                            </mat-form-field>
                            </div>

                            <div class="form-item-row-header" style="grid-column: span 3;flex: 0 0 63.2%;margin-top:20px;">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Terms and Conditions</mat-label>
                                <textarea
                                matInput
                                formControlName="buyerTermsAndConditions"
                                readonly
                                ></textarea>
                            </mat-form-field>
                            </div>
                        </div>
                        </div>

                        <!-- Port Agent Details -->
                        <div class="header-form-header">
                        <span
                            style="
                            padding-left: 16px;
                            padding-top: 16px;
                            margin-bottom: 32px;
                            font-weight: bold;
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;
                            "
                            (click)="toggleVisibility('form10')"
                        >
                            Port Agent Details
                            <mat-icon>{{
                            isForm10Expand ? "minimize" : "add"
                            }}</mat-icon>
                        </span>

                        <div *ngIf="isForm10Expand" class="three-column-flex">
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Port Agency Name</mat-label>
                                  <input matInput formControlName="portAgencyName" readonly/>
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Port Agent Name</mat-label>
                                  <input matInput formControlName="portAgentName" readonly />
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Port Agent Phone Number</mat-label>
                                  <input
                                  matInput
                                  formControlName="portAgentPhoneNumber"
                                  readonly
                                  />
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Port Agent Contact</mat-label>
                                  <input matInput formControlName="portAgentContact" readonly/>
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Port Agent Phone Fax</mat-label>
                                  <input matInput formControlName="portAgentPhoneFax" readonly/>
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Email ID</mat-label>
                                  <input matInput formControlName="portAgentEmail" readonly/>
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header" style="grid-column: span 3">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Address</mat-label>
                                  <input
                                  matInput
                                  formControlName="portAgentAddress"
                                  readonly
                                  >
                              </mat-form-field>
                            </div>
                        </div>
                      </div>


                        <div class="header-form-header">
                          <span
                            style="
                              padding-left: 16px;
                              padding-top: 16px;
                              margin-bottom: 32px;
                              font-weight: bold;
                              display: flex;
                              justify-content: space-between;
                              padding-right: 20px;
                            "
                            (click)="toggleVisibility('form11')"
                          >
                            Freight Forwarder Details
                            <mat-icon>{{ isForm11Expand ? "minimize" : "add" }}</mat-icon>
                          </span>

                          <div *ngIf="isForm11Expand" class="three-column-flex">
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Freight Forwarder Company Name</mat-label>
                                <input matInput formControlName="freightCompanyName" readonly />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>PIC</mat-label>
                                <input matInput formControlName="freightPIC" readonly />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Job Title</mat-label>
                                <input matInput formControlName="freightJobTitle" readonly />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Email ID</mat-label>
                                <input matInput formControlName="freightEmail" readonly />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Phone</mat-label>
                                <input matInput formControlName="freightPhone" readonly />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Fax</mat-label>
                                <input matInput formControlName="freightFax" readonly />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header" style="grid-column: span 3">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Address</mat-label>
                                <input matInput formControlName="freightAddress" readonly />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Packaging</mat-label>
                                <input 
                                  matInput 
                                  formControlName="freightPackaging" 
                                  [matTooltip]="paymentFormGroup.get('freightPackaging')?.value" 
                                  matTooltipPosition="above"
                                  matTooltipShowDelay="500"
                                  readonly 
                                />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Mode of Transport</mat-label>
                                <input 
                                  matInput 
                                  formControlName="freightTransportMode" 
                                  readonly 
                                  [matTooltip]="paymentFormGroup.get('freightTransportMode')?.value" 
                                  matTooltipPosition="above"
                                  matTooltipShowDelay="500"
                                  readonly
                                />
                              </mat-form-field>
                            </div>
                          </div>
                        </div>


                        <!-- Terms and Conditions -->
                        <div class="header-form-header">
                        <span
                            style="
                            padding-left: 16px;
                            padding-top: 16px;
                            margin-bottom: 32px;
                            font-weight: bold;
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;
                            "
                            (click)="toggleVisibility('form12')"
                        >
                            Terms and Conditions
                            <mat-icon>{{
                            isForm12Expand ? "minimize" : "add"
                            }}</mat-icon>
                        </span>

                        <div *ngIf="isForm12Expand" class="three-column-flex">
                            <div class="form-item-row-header" style="grid-column: span 3;margin-top:20px">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Terms and Condition</mat-label>
                                <!-- <input
                                matInput
                                formControlName="termsAndConditions"
                                > -->
                                <textarea
                                matInput
                                formControlName="termsAndConditions"
                                readonly
                                ></textarea>
                            </mat-form-field>
                            </div>

                            
                            
                            <div class="form-item-row-header">
                            <div class="file-name-box">
                                {{
                                getHeaderAttachmentCount() === 0
                                    ? "No files chosen"
                                    : getHeaderAttachmentCount() === 1
                                    ? "1 file chosen"
                                    : getHeaderAttachmentCount() + " files chosen"
                                }}
                                <button
                                    mat-icon-button
                                    *ngIf="getHeaderAttachmentCount() > 0"
                                    (click)="togglePreview(true, 'generalAttachment')"
                                    type="button"
                                >
                                    <mat-icon>visibility</mat-icon>
                                </button>
                            </div>
                            </div>
                        </div>
                        </div>
                    </form>
                  </div>
                  <div style="width:100%;display: flex;justify-content: center;align-items: center;margin-top:20px">
                    <button class="right-button" (click)="isApprovalRequired ? sendBackToList() : save(true)" style="background-color: #FF8900;">
                       {{ isApprovalRequired ? 'Back to List ' : 'Save as Draft' }}
                    </button>
                    <!-- <button class="right-button" (click)="save()" style="background-color: #1F7E3F;">Sent PO</button> -->
                    
                    <button
                        class="right-button"
                        [ngStyle]="{ 'background-color': '#1F7E3F' }"
                        (click)="sendPOForApproval()"
                        *ngIf="isApprovalRequired && !headerResponse?.approvalStatus"
                      >
                        Send for Approval
                      </button>
                    
                    <button
                        class="right-button"
                        [ngStyle]="{ 'background-color': '#9E9E9E' }"
                        [disabled]="true"
                        *ngIf="isApprovalRequired && headerResponse?.approvalStatus === 3"
                      >
                        PO Approval Sent
                      </button>
                    
                    <button
                        class="right-button"
                        [ngStyle]="{ 'background-color': '#1F7E3F' }"
                        (click)="save()"
                        *ngIf="(!isApprovalRequired || headerResponse?.approvalStatus === 1) && headerResponse?.purchaseOrderStatus !== 3"
                      >
                        Send PO
                      </button>
                    
                    <button
                        class="right-button"
                        [ngStyle]="{ 'background-color': '#9E9E9E' }"
                        [disabled]="true"
                        *ngIf="headerResponse?.purchaseOrderStatus === 3"
                      >
                        PO Sent
                      </button>

                  </div>
              </mat-card-content>
          </mat-card>
      </div>
  </div>












    <!-- Popup for confirmation -->
    <div class="namemodal" *ngIf="showCloseDialogue">
        <div class="modalContent">
            <div class="p-6 text-center">
                <div class="flex justify-center mb-4">
                    <div class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center">
                        <mat-icon class="text-orange-600"
                            style="font-size: 40px;  height:100%; width:100%;">warning</mat-icon>
                    </div>
                </div>
                <!-- <h2 class="text-xl font-bold mb-2">You want to save this as draft?</h2> -->
                <p class="mb-6">You want to save this as draft?</p>
                <div class="flex justify-center gap-4">
                    <button mat-raised-button color="primary" (click)="save(true)" style="margin-right: 5px;">YES</button>
                    <button mat-stroked-button (click)="cancel()" style="margin-left:5px">NO</button>
                </div>
            </div>

        </div>
    </div>
</div>


<div
  class="blur"
  *ngIf="previewSection"
  (click)="togglePreview(false, '')"
></div>

<div class="carousel-container" *ngIf="previewSection">
  <!-- Close Button -->
  <div class="carousel-close-button">
    <button class="image-close-button" (click)="togglePreview(false, '')">
      <mat-icon>cancel</mat-icon>
    </button>
  </div>

  <!-- Carousel Content -->
  <div class="carousel">
    <!-- Previous Button -->
    <button class="carousel-control prev" (click)="prevSlide()">
      &#10094;
    </button>

    <!-- Image/PDF Preview -->
    <div class="carousel-image-container">
      <ng-container *ngIf="previewDoc[currentIndex]">
        <div
          class="carousel-preview-inner"
          *ngIf="isPdf(previewDoc[currentIndex]?.dataUrl)"
        >
          <pdf-viewer
            [src]="previewDoc[currentIndex].dataUrl"
            [render-text]="false"
            [page]="1"
            [show-all]="true"
            [original-size]="false"
            class="pdf-content"
          ></pdf-viewer>
        </div>

        <div
          class="carousel-preview-inner"
          *ngIf="!isPdf(previewDoc[currentIndex]?.dataUrl)"
        >
          <img
            [src]="previewDoc[currentIndex]?.dataUrl"
            alt="attachment image"
            class="carousel-image"
          />
        </div>
      </ng-container>
    </div>

    <!-- Next Button -->
    <button class="carousel-control next" (click)="nextSlide()">
      &#10095;
    </button>
  </div>
</div>
